import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Settings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="settings">
      <h1>{t.pages.settingsTitle}</h1>
      <p>{t.pages.settingsDescription}</p>
    </div>
  );
};

export default Settings;
